<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <IreDLQTable />
    </v-card>
  </div>
</template>

<script>
import IreDLQTable from '@/components/ire/IreDLQTable';

export default {
  name: 'IreDLQView',
  components: {
    IreDLQTable,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  .bridge-signing-view {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/ire/IreDLQView.vue